<script>
import confirmationCommandeParDefaut from "@/assets/images/confirmation-commande-par-defaut.gif";
import confirmationCommandeLivraisonDomicile from "@/assets/images/confirmation-commande-livraison-domicile.gif";
import confirmationCommandeTraiteurfete from "@/assets/images/confirmation-commande-traiteurfete.gif";
import confirmationCommandeTraiteur from "@/assets/images/confirmation-commande-traiteur.svg";
import confirmationCommandeClickandcollect from "@/assets/images/confirmation-commande-clickandcollect.gif";
import carteCora from "@/assets/images/carte-mastercard-2.png";
import carteMalin from "@/assets/images/carte-malin-3.png";
import illuPts from "@/assets/images/defis/illu-points-cora.svg";
import illuEurocora from "@/assets/images/defis/illu-eurocora.svg";
import pictoPts from "@/assets/images/picto-pts.png";
import pictoEurocora from "@/assets/images/picto-eurocora.png";
import carteMastercardEtMalin from "@/assets/images/carte-mastercard-et-carte-malin.png";
import cartesCadeau from "@/assets/images/cartes-cadeaux.png";

import { getIconName, MODES_DE_COMMANDE } from "@/utils/mode-commande";
import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import ButtonIcon from "@/components/molecules/button-icon";
const Button = defineAsyncComponent(() => import("@/components/atoms/button"));
import Icon from "@/components/atoms/icon";
import Divider from "@/components/atoms/divider/index";
import Popin from "@/containers/popin-adaptive";
import Titre from "@/components/atoms/titre";
import OrderToCalendar from "@/components/organisms/order-to-calendar";
import CommandeNommer from "@/containers/commande-nommer";
import SecuredDownloadButton from "@/containers/secured-download-button";
import { newlineToBr } from "@/utils/text-transformation";
import MiniPanier from "@/components/organisms/encart-panier/mini-panier";
import AbonnementLadBanniereAbonne from "@/components/organisms/abonnement-lad/panier/abonne";
import panierUtils from "@/utils/panier";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";
import { euroCora, pointFidelite } from "@/composables/text-transformation";

export default {
  name: "OrderConfirmation",
  components: {
    Container,
    LazyImage,
    Button,
    Icon,
    Divider,
    GridRow,
    GridCol,
    Popin,
    OrderToCalendar,
    CommandeNommer,
    SecuredDownloadButton,
    MiniPanier,
    AbonnementLadBanniereAbonne,
    ButtonIcon,
    Titre
  },
  props: {
    commande: {
      type: Object,
      required: false,
      default: null
    },
    service: {
      type: Object,
      required: false,
      default: null
    },
    isPorteurCarteCora: {
      type: Boolean,
      required: true
    },
    isPorteurCarteMalin: {
      type: Boolean,
      required: true
    },
    calendarOptions: {
      type: Object,
      required: true
    },
    paniers: {
      type: Object,
      required: true
    },
    montantPaniers: {
      type: Object,
      required: true
    },
    abonnementInCurrentMagasin: {
      type: Boolean,
      required: false,
      default: false
    },
    isEligibleAbonnementLad: {
      type: Boolean,
      required: false,
      default: false
    },
    montantMinimumLAD: {
      type: Number,
      required: false,
      default: null
    },
    magasin: {
      type: Object,
      required: false,
      default: () => {}
    },
    slideUp: {
      type: Boolean,
      required: false,
      default: false
    },
    isEligibleDefis: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    const { trackEvent } = useInteractionDoneTracking();
    return {
      trackEvent,
      confirmationCommandeParDefaut,
      confirmationCommandeLivraisonDomicile,
      confirmationCommandeTraiteurfete,
      confirmationCommandeClickandcollect,
      carteCora,
      carteMalin,
      pictoPts,
      pictoEurocora,
      illuPts,
      illuEurocora,
      carteMastercardEtMalin,
      cartesCadeau
    };
  },
  data() {
    return {
      titre: "",
      MODES_DE_COMMANDE
    };
  },
  computed: {
    ButtonComponent() {
      return Button;
    },
    iconName() {
      return getIconName(this.service ? this.service.type_picto.code : null);
    },
    libelleBoutonImpression() {
      return this.service &&
        (this.service.mode_commande_type === MODES_DE_COMMANDE.lad ||
          this.service.mode_commande_type === MODES_DE_COMMANDE.lee ||
          this.service.mode_commande_type === MODES_DE_COMMANDE.lc)
        ? "Imprimer le récapitulatif de commande"
        : "Imprimer le bon de retrait";
    },
    commandeAttributes() {
      return this.commande.data.attributes;
    },
    isPaidWithCKDO() {
      return this.commandeAttributes?.modes_paiement?.some(
        (mode) => mode?.type === "CKDO"
      );
    },
    orderConfirmationDeliveryInfo() {
      if (this.service) {
        const modeCommande = this.service.mode_commande_type.toLowerCase();
        return defineAsyncComponent(() =>
          import(`./delivery-info/${modeCommande}.vue`)
        );
      }
      return null;
    },
    nomCommande() {
      return this.titre || this.commandeAttributes.titre;
    },
    warningSacs() {
      return (
        this.service.mode_commande_type === MODES_DE_COMMANDE.drive &&
        !this.commandeAttributes.avec_sacs
      );
    },
    checkSoldLink() {
      return useRuntimeConfig().public.OGLOBA_CHECK_SOLD;
    },
    infoNonRetrait() {
      if (this.service) {
        return newlineToBr(this.service.info_non_retrait);
      }
      return "";
    },
    typesPaniers() {
      return Object.keys(this.paniers);
    },
    libelleTypePanierCommandeLong() {
      return panierUtils.getLabelByTypePanier(
        this.commandeAttributes.type_panier,
        true
      );
    },
    libelleTypePanierCommande() {
      return panierUtils.getLabelByTypePanier(
        this.commandeAttributes.type_panier
      );
    },
    iconTypePanierCommande() {
      switch (this.commandeAttributes.type_panier) {
        case "click_and_collect":
          return confirmationCommandeClickandcollect;
        case "click_and_collect_traiteur_permanent":
          // TODO : GIF K2 TRAITEUR
          return confirmationCommandeTraiteur;
        case "click_and_collect_traiteur_noel":
          return confirmationCommandeTraiteurfete;
        case "ldd":
          return confirmationCommandeLivraisonDomicile;
        default:
          return confirmationCommandeParDefaut;
      }
    }
  },
  mounted() {
    if (this.isPaidWithCKDO) {
      this.$refs.ckdoPopin.show();
    }
  },
  methods: {
    showPopinCalendar() {
      this.$refs.popinCalendar.show();
    },
    showPopinRenameCommande() {
      this.$refs.renommer.show();
    },
    hidePopinRenameCommande(titre) {
      this.titre = titre;
      this.$refs.renommer.hide();
    },
    showMap() {
      const url =
        "http://www.google.com/maps/place/" +
        this.service.gps.latitude +
        "," +
        this.service.gps.longitude;
      const win = window.open(url, "_blank");
      win.focus();
    },
    printFile() {
      this.trackEvent({
        actionGA: trackingCodes.ACTIONGA.printTicket,
        categoryGA: trackingCodes.CATEGORYGA.orderConfirmation,
        labelGA: ""
      });
    }
  }
};
</script>

<template>
  <div
    v-if="commande"
    id="content"
    role="main"
    class="c-order-confirmation u-bgcolor-white u-pb-xlg"
  >
    <div class="u-text-center@sm u-pt-lg u-pr-sm@sm u-pl-sm@sm">
      <Container>
        <div class="u-px-xxlg u-px-xlg@lg u-px-none@sm">
          <GridRow class="u-flex-column-reverse@sm u-flex-align-center">
            <GridCol
              cols="6"
              sm="12"
            >
              <h1 class="u-font-24 u-color-primary u-mb-sm@sm">
                Votre commande {{ libelleTypePanierCommandeLong }} est réussie !
              </h1>
              <p class="u-font-15 u-mt-xxs">
                <template v-if="commandeAttributes.type_panier === 'ldd'">
                  Un e-mail de confirmation de commande vient de vous être envoyé à l’adresse {{ commandeAttributes.adresse.email }}.
                </template>
                <template v-else>
                  Un e-mail de confirmation de commande vient de vous être envoyé à l’adresse {{ commandeAttributes.adresse.email }} avec un bon de retrait en pièce jointe.
                </template>
              </p>
            </GridCol>
            <GridCol
              cols="4"
              offset="2"
              offset-sm="0"
              sm="12"
            >
              <LazyImage
                :src="iconTypePanierCommande"
                width="150"
                height="150"
                class="u-inline-block"
              />
            </GridCol>
          </GridRow>
        </div>
      </Container>
    </div>

    <div class="u-bgcolor-grey-8 u-pt-xlg u-pb-lg c-order-confirmation__content">
      <template v-if="typesPaniers.length > 0">
        <h1 class="u-font-24 u-text-center u-mb-md u-px-sm@sm">
          N'oubliez pas, il vous reste {{ typesPaniers.length }} panier{{ typesPaniers.length > 1 ? 's' : '' }} en attente
        </h1>
        <Container>
          <div class="u-flex u-flex-justify-center u-flex-column@md u-flex-align-center@md u-px-xlg u-px-none@md">
            <MiniPanier
              v-for="typePanier in typesPaniers"
              :key="typePanier"
              :type-panier="typePanier"
              :produits="paniers[typePanier]"
              :can-show-detail="false"
              :montant-total-t-t-c="montantPaniers[typePanier]"
              class="u-mx-sm u-mx-none@md u-flex-item-fluid u-mb-md@md u-full-width@md"
              style="max-width:52rem;"
            >
            </MiniPanier>
          </div>
        </Container>
      </template>
      <div class="c-order-confirmation__shape"></div>
    </div>

    <div class="c-order-confirmation__recap">
      <h1 class="u-font-24 u-color-primary u-text-center@sm u-mb-md">
        Récapitulatif de ma commande {{ libelleTypePanierCommande }}
      </h1>
      <div class="u-border-grey-4 u-pt-md u-pb-md u-pl-sm u-pr-sm u-radius-sm u-mb-md">
        <div class="u-flex u-flex-column@md u-flex-align-center u-flex-align-start@md u-mb-sm">
          <div class="u-mr-lg u-mr-xs@md">
            <p class="u-font-17 u-font-500 u-font-700@md u-font-secondary@md">
              N° de commande {{ commandeAttributes.code }}
            </p>
            <p
              v-if="nomCommande"
              class="u-color-text-light u-mt-xs"
            >
              {{ nomCommande }}
            </p>
          </div>
          <div class="u-mr-lg u-mr-xs@md u-mt-xs@md">
            <Button
              link
              @click="showPopinRenameCommande"
            >
              <template v-if="nomCommande">
                Renommer ma commande
              </template>
              <template v-else>
                Nommer ma commande
              </template>
            </Button>
          </div>
          <div class="u-mt-sm@md u-ml-auto u-ml-none@md">
            <Button
              radius="full"
              size="sm"
              variant="primary"
              :to="`/mon-compte/mes-commandes/${commande.data.id}?archive=${commandeAttributes.is_archive}`"
            >
              Voir le détail
            </Button>
          </div>
        </div>
        <Divider
          dotted
          size="sm"
        />
        <div class="u-mt-md u-mt-sm@sm u-font-17 u-flex u-flex-column">
          <p class="u-inline-flex u-flex-align-center u-font-500 u-mb-xs u-mb-md@sm">
            <Icon
              :name="iconName"
              variant="primary"
              class="u-mr-xs u-flex-shrink-none"
            />
            {{ commandeAttributes.type_commande }}
          </p>
          <div
            v-if="service.mode_commande_type === MODES_DE_COMMANDE.lc || service.mode_commande_type === MODES_DE_COMMANDE.lad || service.mode_commande_type === MODES_DE_COMMANDE.ldd"
            class="u-inline-flex u-flex-align-center u-flex-align-start@md u-mb-xs u-mb-md@sm"
          >
            <Icon
              name="location-outline"
              variant="primary"
              class="u-mr-xs u-flex-shrink-none"
            />
            <div class="u-pt-xxs@md u-flex u-block@md">
              <p class="u-mr-xs">
                {{ commandeAttributes.description }}
              </p>
            </div>
          </div>
          <div
            v-else-if="service.adresse"
            class="u-inline-flex u-flex-align-center u-flex-align-start@md u-mb-xs u-mb-md@sm"
          >
            <Icon
              name="location-outline"
              variant="primary"
              class="u-mr-xs u-flex-shrink-none"
            />
            <div class="u-pt-xxs@md u-flex u-block@md">
              <p class="u-mr-xs">
                <template v-if="service.description">
                  {{ service.description }} -
                </template>
                {{ service.adresse }}
              </p>
              <Button
                v-if="service.gps"
                link
                class="u-ml-xs u-ml-none@md"
                @click="showMap"
              >
                <span class="u-font-14">Voir le plan d'accès</span>
              </Button>
            </div>
          </div>
          <div class="u-inline-flex u-flex-align-center u-flex-align-start@sm">
            <Icon
              name="calendar"
              variant="primary"
              class="u-mr-xs u-flex-shrink-none"
            />
            <p class=" u-pt-xxs@sm u-flex u-block@md">
              {{ commandeAttributes.statut_long }}
            </p>
          </div>
          <div
            v-if="warningSacs"
            class="u-inline-flex u-flex-align-center u-flex-align-start@sm  u-mt-xs u-mt-md@sm"
          >
            <Icon
              name="sac-consignes"
              variant="primary"
              class="u-mr-xs u-flex-shrink-none"
            />
            <p class=" u-pt-xxs@sm u-flex u-block@md">
              Vous avez choisi d’amener vos propres sacs pour ranger vos courses, n’oubliez pas de les prendre avec vous lors du retrait de votre commande.
            </p>
          </div>
        </div>
        <div class="u-flex u-flex-column@sm u-flex-align-center u-flex-align-start@sm u-flex-justify-start u-mt-md u-mt-lg@sm">
          <Button
            radius="full"
            outline
            size="sm"
            variant="primary"
            class="u-mb-sm@sm u-mr-sm u-mr-none@sm"
            @click="showPopinCalendar"
          >
            Ajouter à mon agenda
          </Button>
          <SecuredDownloadButton
            v-if="commandeAttributes.type_panier !== 'ldd'"
            :component="ButtonComponent"
            radius="full"
            outline
            size="sm"
            variant="primary"
            :secured-link="commandeAttributes.url_pdf"
            @download="printFile"
          >
            {{ libelleBoutonImpression }}
          </SecuredDownloadButton>
        </div>
      </div>
      <div class="u-mb-md">
        <AbonnementLadBanniereAbonne
          v-if="commandeAttributes.code_type_commande === 'LAD' && isEligibleAbonnementLad && abonnementInCurrentMagasin"
          :date-fin="abonnementInCurrentMagasin.attributes.date_fin"
          :montant-minimum="montantMinimumLAD"
          confirmation
        />
      </div>
      <component
        :is="orderConfirmationDeliveryInfo"
        :code="commandeAttributes.code"
        :pdf-url="commandeAttributes.url_pdf"
        :lieu-retrait="service.description"
        :magasin="magasin"
        :popin-slide-up="slideUp"
      />
      <div
        v-if="isPaidWithCKDO"
        class="u-border-grey-4 u-p-md u-radius-sm u-mb-md"
      >
        <div class="u-flex u-flex-align-center u-full-width u-gap-sm">
          <LazyImage
            :src="cartesCadeau"
            alt="carte cadeau"
            width="76"
            height="39"
          />
          <p class="c-payment-method-wrapper-grid-texte u-font-17 u-text-left@xs">
            Votre Carte Cadeau Cora
          </p>
        </div>
        <Divider
          dotted
          size="sm"
          class="u-mb-md"
        />
        <div class="u-flex u-flex-column u-gap-xs">
          <div class="u-flex u-flex-align-center u-flex-align-start@md">
            <Icon
              name="info-circle-outline"
              variant="primary"
              class="u-mr-sm u-flex-shrink-none"
              size="md"
            />
            <p>
              Conservez votre Carte Cadeau Cora jusqu’au retrait ou la réception de votre commande.
              <br>
              Ou jusque votre prochaine commande si vous n'avez pas encore utilisé le montant total de votre carte.
            </p>
          </div>
          <div class="u-flex u-flex-align-center">
            <Icon
              name="solde-carte-cadeau"
              variant="primary"
              class="u-mr-sm u-flex-shrink-none"
              size="md"
            />
            <ButtonIcon
              icon-name="lien-externe"
              icon-position="right"
              icon-size="sm"
              link
              :href="checkSoldLink"
            >
              <span class="u-font-16">Consulter le solde de votre carte</span>
            </ButtonIcon>
          </div>
        </div>
      </div>
    </div>
    <Popin
      v-if="isPaidWithCKDO"
      ref="ckdoPopin"
      aria-label="Carte cadeau popin"
    >
      <div class="u-flex u-flex-column u-flex-align-center u-mt-xs">
        <Icon
          variant="secondary"
          name="info-circle-outline"
        />
        <Titre
          tag="h1"
          size="md"
          variant="primary"
          class="u-text-center u-mt-sm u-mb-sm u-mb-xs@md u-my-lg@xs"
        >
          Conservez bien votre Carte Cadeau Cora
        </Titre>
        <p class="u-text-center u-px-lg u-mb-sm u-mb-lg@xs">
          Veillez à bien conserver votre Carte Cadeau Cora tant que votre commande n'a pas été retirée ou réceptionnée !
        </p>
        <div class="u-flex u-flex-justify-center u-flex-align-center u-gap-sm">
          <Button
            size="lg"
            radius="full"
            variant="primary"
            class="u-mb-sm"
            @click="$refs.ckdoPopin.hide()"
          >
            J'ai compris
          </Button>
        </div>
      </div>

    </Popin>

    <Popin
      ref="popinCalendar"
      aria-label="Calendrier"
      size="lg"
    >
      <OrderToCalendar
        :title="calendarOptions.title"
        :start="calendarOptions.start"
        :duration="calendarOptions.duration"
        :end="calendarOptions.end"
        :address="calendarOptions.address"
        :description="calendarOptions.description"
      />
    </Popin>

    <Popin
      ref="renommer"
      aria-label="Nommer la commande"
    >
      <CommandeNommer
        :name="nomCommande"
        :commande="commande.data"
        @validate="hidePopinRenameCommande"
      />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/order-confirmation.scss";
</style>
